export default {
  apiServer: 'https://api.zhenheyiliao.cn/',
  apiAppId: 'BigShow',
  apiAppSecret: 'NUGNDHSHCJUFDRJMVLPHXYWZLYPOJMXD',
  apiVersion: '3.0.0',
  socketUrl: 'wss://api.zhenheyiliao.cn:2348/',
  appid: 'wx30fdd07e2ac1d0f4',
  path: 'https://gzh.zhenheyiliao.cn/learn/#',
  imgHost: 'https://ics.zhenheyiliao.cn/',
};



// WEBPACK FOOTER //
// ./src/config/index.js